import { create } from "zustand";
import { persist } from "zustand/middleware";

export type CabinetRole = "advertiser" | "blogger";

type State = {
  /** null until the startup modal has been answered once. */
  role: CabinetRole | null;
  /** Which blogger's inbox we're viewing when role === "blogger". */
  activeBloggerId: string | null;
};

type Actions = {
  setRole: (role: CabinetRole) => void;
  setActiveBloggerId: (id: string | null) => void;
};

export const useRoleStore = create<State & Actions>()(
  persist(
    (set) => ({
      role: null,
      activeBloggerId: null,
      setRole: (role) => set({ role }),
      setActiveBloggerId: (activeBloggerId) => set({ activeBloggerId }),
    }),
    { name: "lk2-role-v1" },
  ),
);
